'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = Icon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icons = require('@wh/icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Icon Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function Icon(props) {
    var _props$imageSrc = props.imageSrc,
        imageSrc = _props$imageSrc === undefined ? '' : _props$imageSrc,
        _props$colour = props.colour,
        colour = _props$colour === undefined ? '' : _props$colour;


    var iconImageStyles = {
        backgroundImage: 'url(' + imageSrc + ')'
    };

    var iconStyles = {
        backgroundColor: colour
    };

    if (imageSrc) {
        return _react2.default.createElement(_icons2.default, (0, _extends3.default)({ style: iconImageStyles }, props));
    }

    return _react2.default.createElement(_icons2.default, (0, _extends3.default)({ style: iconStyles }, props));
}
// components
//# sourceMappingURL=Icon.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/icon/Icon.js
// module id = 558
// module chunks = 0